// import utility functions
import {
  calculateNumeratorDenominatorPayment,
  calculatePrincipalRateTerm,
  formatCurrencyString,
} from '../util';

// import amortized payments function
import calculateAmortizationSchedule from './calculateAmortizationSchedule';

import deformatCurrency from '../util/deformatCurrency';

/**
 * Calculate monthly mortgage payment for a loan
 * Also calculate amortization schedule, i.e. payments broken down by month over the timespan chosen
 * Formula for this was adapated from the old PHP calculators OTHL sites used to use
 *
 * Parameters are all values from inputs
 *
 * @param {string} totalHomeLoanAmount
 * @param {string} annualInterestRate
 * @param {string} termOfTheLoan
 * @return {[string, object]} [monthly payment, amortized payments]
 */
function calculateMortgagePayment(
  totalHomeLoanAmount,
  annualInterestRate,
  termOfTheLoan,
  additionalItems,
  downPayment
) {
  const [principal, rate, term] = calculatePrincipalRateTerm({
    totalHomeLoanAmount,
    annualInterestRate,
    termOfTheLoan,
    downPayment,
  });

  // don't use numerator or denominator here
  const [, , payment] = calculateNumeratorDenominatorPayment({
    rate,
    term,
    principal,
  });

  const amortizedPayments = calculateAmortizationSchedule(
    principal,
    rate,
    term,
    payment
  );

  // additionalitems is an object and deformatCurrency
  // add them to payment

  let additionalTotalToAdd = 0;

  for (const key in additionalItems) {
    if (additionalItems.hasOwnProperty(key)) {
      let deformatted = deformatCurrency(additionalItems[key]);
      console.log(typeof deformatted);
      additionalTotalToAdd += Number(deformatted);
    }
  }

  console.log(
    typeof payment,
    typeof additionalTotalToAdd,
    typeof principal,
    principal
  );
  console.log(Number(payment) + Number(additionalTotalToAdd));
  console.log(Number(payment), Number(additionalTotalToAdd));
  return [
    formatCurrencyString(Number(payment) + Number(additionalTotalToAdd)),
    amortizedPayments,
    formatCurrencyString(Number(principal)),
  ];
}

export default calculateMortgagePayment;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/mortgagePaymentCalculator/calculateMortgagePayment.js